export default __webpack_public_path__ + "static/teamAugmentationBanner-a91812e73a525ff2022e6377ba2a8178.jpeg";